import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
var randomstring = require("randomstring");

class Alert extends Component {
  constructor(props) {
    super(props);
    this.alertId = randomstring.generate(20);
    this.baslik = props.baslik||"Hata: Başlık Belirtilmemiş.";
    this.content = props.content||"Hata: İçerik Belirtilmemiş.";
    this.onay = props.onay;
    this.onayLink = props.onayLink;
    this.red = props.red;
    this.opened = props.opened;
    this.state = {
      opened: this.opened,
    }
    this.aç = this.aç.bind(this);
    this.kapat = this.kapat.bind(this);
  }


  aç() {
    document.getElementById(this.alertId+"alert-div").style.display = "block";
  }

  kapat() {
    document.getElementById(this.alertId+"alert-div").style.display = "none";
  }

  render() {
    if (this.props.opened == true) this.aç();
    return (
    <div style={this.state.opened == false ? {display: "none"} : {display: "block"}} id={this.alertId+"alert-div"}>
      <div className="overlay"></div>
      <div className="alert">
        <a>{this.baslik}</a>
        <p>{this.content}</p>
        {this.red ? <a ><button className="red" onClick={this.kapat}>{this.red}</button></a> : ""}
        {this.onay ? <a href={this.onayLink}><button className="onay">{this.onay}</button></a> : ""}
      </div>

      <style>{`
        .overlay {
          top: 0;
          left: 0;
          background: #000;
          position: fixed;
          width: 100%;
          height: 100%;
          opacity: 0.4;
          z-index: 99;
        }

        .alert {
          top: 50%;
          margin-top: -75px;
          left: 50%;
          margin-left: -150px;
          background: #fff;
          width: 300px;
          height: 150px;
          opacity: 1;
          z-index: 999;
          position: fixed;
          border-radius: 5px;
          text-align: center;
          padding: 20px 10px;
        }

        .alert a {
          color: #000;
          font-size: 30px;
          font-weight: bold;
        }

        .alert p {
          color: #000;
          font-size: 18px;
          margin-top: 15px;
        }

        .alert button {
          margin-top: 10%;
          outline: none;
        }

        .onay {
          padding: 10px;
          background: #ccc;
          border: 1px solid #000;
        }

        .onay:hover {
          background: #F57029;
          color: #fff;
        }

        .red {
          padding: 10px;
          margin-right: 10px;
          background: none;
          border: 1px solid #000;
        }

        .red:hover {
          background: #000;
          color: #fff;
        }

        @media (max-width: 623px) {
          .alert {
            width: 100%;
            height: 100%;
            left: 0;
            padding: 20px 0px;
            margin: 0;
          }
        }
      `}</style>

    </div>
  )}
}

Alert.propTypes = {
  baslik: PropTypes.string,
  content: PropTypes.string,
  onay: PropTypes.string,
  onayLink: PropTypes.string,
  red: PropTypes.string,
  opened: PropTypes.bool,
}
export default Alert;